import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { SitiService } from 'src/app/shared/services/siti.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-siti',
  templateUrl: './siti.component.html',
  imports: [
    DxDataGridComponent,
    DxiColumnComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoExportComponent,
  ],
  standalone: true,
})
export class SitiComponent extends GestArticoliBaseComponent implements OnInit {
  private sitiService = inject(SitiService);
  dataSource: any;

  ngOnInit() {
    this.loadDataSource();
  }

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.sitiService.list())
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        return firstValueFrom(this.sitiService.insert(values))
          .then((res) => {
            this.sitiService.listTemp(true).subscribe();
            return res;
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Insert failed';
            }
          });
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.sitiService.remove(values))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => {
              console.log('delete eseguito');
              this.sitiService.listTemp(true).subscribe();
            })
            .catch((error: HttpErrorResponse) => {
              if (error.status == 500) {
                throw error.error.title;
              } else {
                throw 'Deletion failed';
              }
            })
        );
      },
      update: (key, values) => {
        return firstValueFrom(this.sitiService.update(key, values))
          .then(() => {
            this.sitiService.listTemp(true).subscribe();
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Update failed';
            }
          });
      },
    });
  }

  onExporting(e: any) {
    GridExportExcel(e, 'Siti', 'Siti.xlsx');
  }
}
